import { useCallback, useEffect, useRef, useState } from "react";
import { api, apiErr } from "./api";

// Loads one or more admin endpoints; refetches whenever `deps` change.
export function useAdminData(loader, deps) {
  const [state, setState] = useState({ data: null, loading: true, error: "" });
  const seq = useRef(0);
  const run = useCallback(async () => {
    const id = ++seq.current;
    setState((s) => ({ ...s, loading: true, error: "" }));
    try {
      const data = await loader(api);
      if (id === seq.current) setState({ data, loading: false, error: "" });
    } catch (e) {
      if (id === seq.current) setState((s) => ({ ...s, loading: false, error: apiErr(e) }));
    }
  }, deps);
  useEffect(() => { run(); }, [run]);
  return { ...state, reload: run };
}
